import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DocumentGenerationTemplate_FieldsFragment } from 'queries';

import Modal from 'common/modal';

const useStyles = makeStyles(() => ({
  title: {
    fontWeight: 700,
    fontSize: '20px',
    marginBottom: '30px',
    textAlign: 'left',
  },
  instructionsContent: {
    padding: '8px',
    borderRadius: '8px',
    border: '1px solid #E0E0E0',
    background: '#F5F5F5',
    fontSize: '14px',
  },
}));

type Props = {
  setShowModal: (value: boolean) => void;
  showModal: boolean;
  documentGenerationTemplate?: DocumentGenerationTemplate_FieldsFragment;
};

const InstructionsModal = ({ setShowModal, showModal, documentGenerationTemplate }: Props) => {
  const classes = useStyles();

  const onExitClick = () => {
    setShowModal(false);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <>
          <Typography className={classes.title}>Instructions</Typography>
          <div className={classes.instructionsContent}>
            {documentGenerationTemplate?.instructions || 'N/A'}
          </div>
        </>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
};

export default InstructionsModal;
